import { Box, Typography } from "@mui/material";
import { SectionHeading } from "../../../components/SectionHeading";
import { FramedImage } from "../../../components/FramedImage";

export function Founders({ image }) {
  return (
    <Box
      component="section"
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1.1fr 1fr" },
        gap: { xs: 6, md: 10 },
        alignItems: "center",
      }}
    >
      <FramedImage src={image} alt="Nicolas e Luis Augusto tocando ao vivo" aspectRatio="3 / 2" maxWidth={600} />

      <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
        <SectionHeading overline="Quem está à frente" title="Nicolas e Luis Augusto" align="inherit" />
        <Typography sx={{ mt: { xs: -2, md: -4 }, color: "text.secondary", fontSize: { xs: "1rem", md: "1.1rem" }, lineHeight: 1.8 }}>
          À frente desse projeto estão{" "}
          <Box component="strong" sx={{ color: "text.primary", fontWeight: 600 }}>
            Nicolas e Luis Augusto
          </Box>
          , músicos que reúnem uma ampla bagagem musical, construída por meio de experiências, apresentações e anos de
          dedicação à música. Essa vivência nos permite unir técnica, sensibilidade e versatilidade em cada
          apresentação, sempre buscando entregar muito mais do que música: queremos criar atmosferas, despertar emoções
          e transformar momentos em memórias.
        </Typography>
      </Box>
    </Box>
  );
}
